import React, { useState, useEffect } from "react";
// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
import T from "./TheTool";
import Timer from "./TheTimer";
import GUIset_Single from "./gui/GUIset_Single";
import Template from "./TheTemplate";

const Freq = () => {
	useEffect(() => {
		document.title =
			"Non-Repeating Character";
	}, []);

	const [guiTxt1, guiTxtChange1] = useState(
		"IISVIVGXBSVISCNBVBNVAGYIXZVZTY"
	);
	//----
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			arr = T.str_toListInt(guiTxt1);
			Timer.start();
			process();
			txt_time = Timer.stop_print();
			//--------------------------
			BuildResult();
			arr = [];
		}
	};

	var arr = [];
	var txt_time = "";
	var txt_result = "";

	function process() {
		var txt_nonR = "";
		var txt_R = "";
		var txt = guiTxt1;
		while(true){
			var txt2 = "";
			if(txt.length < 1){ break; }
			var x = txt[0];
			var repeat = false;
			for(var i = 1; i < txt.length; i++){
				if(x == txt[i]){
					repeat = true;
				}
				else{
					txt2 += txt[i];
				}
			}
			if(!repeat) { txt_nonR += x; } 
			else { txt_R += x; }
			var txt = txt2;
		}
		//
		txt_result = "Non-repeating\n" + txt_nonR + "\n\nRepeating\n" + txt_R;
	}

	//-------------------------

	function BuildResult() {
		var txt = txt_time + "\n\n";
		// partResultChange(
		// 	<div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>
		// 			<h2>Result</h2>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 20 }}>{txt}</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 22 }}>{txt_result}</div>
		// 	</div>
		// );
		partResultChange(Template.simple3size("key1","Result",txt,txt_result,22,20,22));
	}

	//--------------------------------------------------------

	return (		
		<GUIset_Single
			title={"Non-Repeating Character"}
			desc={"Finding unique character in a string."}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"Array"}
			isNumOnly = {false}
			txtButton = {"Analyze"}
		/>
		// <div className="todoapp stack-large">
		// 	<GUI_Header
		// 		title={"Non-Repeating Character"}
		// 		desc={
		// 			"Finding unique character in a string."
		// 		}
		// 	/>
		// 	<div style={{ marginTop: "3em" }}> </div>
		// 	<GUI_InputTextSingle
		// 		label={"Array"}
		// 		text1={guiTxt1}
		// 		text1Change={guiTxtChange1}
		// 		numberOnly={false}
		// 		width1={100}
		// 		fontSize2={24}
		// 		width2={'100%'}
		// 	/>
		// 	<div style={{ display: "flex", marginLeft: '14%', marginRight: 0 }}>
		// 		<button
		// 			onClick={() => buttonClick1()}
		// 			className="btn btn__primary btn__lg"
		// 			style={{ flex: 1, height: 50 }}
		// 		>
		// 			Analyze
		// 		</button>
		// 	</div>
		// 	<div style={{ marginTop: "3em" }}> </div>
		// 	{partResult}
		// 	<GUI_Credit />
		// </div>
	);
};

export default Freq;
